module.exports = __webpack_public_path__ + "static/media/blackfridaypingme.168f3a82.png";